import { render, staticRenderFns } from "./FireComponent.vue?vue&type=template&id=ab3aaa46&scoped=true&"
import script from "./FireComponent.vue?vue&type=script&lang=js&"
export * from "./FireComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3aaa46",
  null
  
)

export default component.exports